import "./Home.module.css";
import TopNavigation from "@/reusable_sections/Header";
import UltimateSmokingExperience from "./sections/UltimateSmokingExperience";
import TheArtBehindTheSmoke from "./sections/TheArtBehindTheSmoke";
import OurEliteCuts from "./sections/OurEliteCuts";
import YourGoExperience from "./sections/YourGoExperience";
import CarnivoreTestimonials from "./sections/CarnivoreTestimonials";
import JoinTheSmokedClub from "./sections/JoinTheSmokedClub";
import FooterSection from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <TopNavigation />
      <UltimateSmokingExperience />
      <TheArtBehindTheSmoke />
      <OurEliteCuts />
      <YourGoExperience />
      <CarnivoreTestimonials />
      <JoinTheSmokedClub />
      <FooterSection />
    </div>;
}